import { useNavigate } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]" data-testid="payment-cancel-page">
      <div className="card-flat max-w-md w-full p-10 text-center">
        <XCircle size={56} weight="duotone" className="mx-auto text-amber-600" />
        <h1 className="font-display text-2xl font-bold text-slate-900 mt-4">Payment cancelled</h1>
        <p className="text-sm text-slate-500 mt-2">The client didn't complete the checkout. You can send the link again anytime.</p>
        <Button onClick={() => navigate("/invoices")} className="mt-6 bg-[#1E3A8A] hover:bg-[#1E40AF] text-white">Back to invoices</Button>
      </div>
    </div>
  );
}
